import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaLock, FaSignInAlt } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import { login } from '../utils/authService';

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    try {
      await login(form);
      navigate('/dashboard');
    } catch (err) {
      setError(err.message || 'Login failed.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mx-auto max-w-md px-4 py-16">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
        <div className="mb-6 text-center">
          <div className="mx-auto mb-4 grid h-14 w-14 place-items-center rounded-full bg-[#00595A] text-white">
            <FaLock />
          </div>
          <h1 className="text-2xl font-semibold text-slate-900">{t('auth.loginTitle')}</h1>
          <p className="mt-2 text-sm text-slate-500">{t('auth.loginSubtitle')}</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700">{t('auth.email')}</label>
            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1 w-full rounded-lg border border-slate-200 px-4 py-3 focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200" />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700">{t('auth.password')}</label>
            <input type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1 w-full rounded-lg border border-slate-200 px-4 py-3 focus:border-sky-400 focus:outline-none focus:ring-2 focus:ring-sky-200" />
          </div>

          {error ? <p className="rounded-lg bg-rose-50 px-4 py-3 text-sm text-rose-700">{error}</p> : null}

          <button disabled={loading} className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-[#00595A] px-4 py-3 font-semibold text-white transition hover:bg-[#004446] disabled:opacity-60">
            <FaSignInAlt /> {loading ? t('auth.loggingIn') : t('auth.login')}
          </button>
        </form>

        <p className="mt-4 text-center text-sm text-slate-500">
          {t('auth.noAccount')} <Link to="/register" className="font-semibold text-[#00595A]">{t('auth.register')}</Link>
        </p>
      </div>
    </section>
  );
};

export default Login;
